export const uploadFiles = (files, urlName, formName, formDataName, successFn, failFn ) => ({type: 'UPLOAD_FILE', path: urlName, files, formName, formDataName, successFn, failFn});
export const downloadFile = (urlName) => ({type: 'DOWNLOAD_FILE', path: urlName});
export const resetFile = (formName) => ({type: 'RESET_FILE', path: formName});
export const resetFileError = (formName) => ({type: 'RESET_FILE_ERROR', path: formName});
export const resetFileStatus = (formName) => ({type: 'RESET_FILE_STATUS', path: formName});

export const filePending = (formName) => ({type: 'FILE_PENDING', path: formName});
export const fileFailed = (formName, error) => ({type: 'FILE_FAILED', path: formName, error});
export const fileSuccess = (formName, data) => ({type: 'FILE_SUCCESS', path: formName, data});
